import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpStatusCode } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { RequestService } from "projects/store/src/app/services/api/v1/request.service";
import { SalesWorkflowService } from "projects/store/src/app/services/api/v1/sales-workflow.service";
import { ResponseHttpError, CustomMessageService } from "library";
import {UtilService} from "library";

@Component({
  selector: 'app-sales-search-request',
  templateUrl: './sales-search-request.component.html',
  styles: []
})
export class SalesSearchRequestComponent implements OnInit {

  @Output() nextStepEvent = new EventEmitter();

  private requestService = inject(RequestService);
  private salesWorkflowService = inject(SalesWorkflowService);
  private customMessageService = inject(CustomMessageService);
  private utilService = inject(UtilService);

  form!: FormGroup;
  submitted = false;
  loading = false;
  viewForm = true;
  documentTypeList: any[] = environment.global.country.documentTypeOptions;
  errorMessage: string = '';

  ngOnInit(): void {
    this.utilService.disablePageLoading();
    this.form = new FormGroup({
      document_id_type: new FormControl('', [Validators.required]),
      document_id_number: new FormControl('', [Validators.required])
    });
  }

  get f() {
    return this.form.controls;
  }

  save(): void {
    this.submitted = true;
    this.errorMessage = '';
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    const documentNumber = this.form.get('document_id_number')?.value;
    const salesFlowId = this.salesWorkflowService.workflow.id;

    this.requestService.searchRequest(documentNumber, salesFlowId).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (resp.status === HttpStatusCode.Ok) {
          const requestId = resp.body?.data?.request_id;
          this.nextStepEvent.emit({ requestId });
        }
      },
      error: (error: ResponseHttpError) => {
        this.loading = false;
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.errorMessage = error.error?.message || 'No se encontró una solicitud con ese documento.';
        } else {
          this.customMessageService.comunicationError();
        }
      }
    });
  }
}
